function getSaasWebHostname() {
  try {
    return new URL(process.env.VUE_APP_SAAS_WEB_URL).hostname;
  } catch (error) {
    return "";
  }
}

function isHostedWebPageInElectron() {
  const protocol = window.location.protocol;
  return (
    window.isElectron &&
    (protocol === "http:" || protocol === "https:") &&
    window.location.hostname &&
    window.location.hostname === getSaasWebHostname()
  );
}

const getters = {
  user: (state) => {
    if (window.isElectron) {
      if (isHostedWebPageInElectron()) {
        // 这是嵌套的网页
        return state.userInfo.profile;
      }
      return state.user.userInfo;
    } else {
      return state.userInfo.profile;
    }
  },
  isAuthenticated: (state, getters) => {
    return getters.user && !!getters.user.user_id;
  },
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
};
export default getters;
